module.exports = __webpack_public_path__ + "assets/img/cloud1.95c82fa2.png";